import * as pattern from 'ts-pattern';
export const get = (path) => (object) => {
    return path.reduce((valueSoFar, pathFragment) => {
        if (!valueSoFar) {
            return undefined;
        }
        return valueSoFar[pathFragment];
    }, object);
};
export const match = pattern.match;
//# sourceMappingURL=functional.js.map